import { BaseEntity } from "yt-ng-framework";

export class KontniPlanView extends BaseEntity{
    constructor(){
        super();
    }


    Konto: string;
    Naziv: string;
    ImaAna: boolean;
    VrstaKontnogPlana: string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Konto=input.Konto;
        this.Naziv=input.Naziv;
        this.ImaAna=input.ImaAna;
        this.VrstaKontnogPlana=input.VrstaKontnogPlana;
        return this;
    }
    Serialize(input:KontniPlanView){
        return input;
    }
}